export const fr = {
  accept: 'Oui',
  addRule: 'Ajouter une règle',
  am: 'am',
  apply: 'Appliquer',
  cancel: 'Annuler',
  choose: 'Choisir',
  chooseDate: 'Choisir une date',
  chooseMonth: 'Choisir un mois',
  chooseYear: 'Choisir une année',
  clear: 'Effacer',
  contains: 'Contient',
  dateAfter: 'Après le',
  dateBefore: 'Avant le',
  dateFormat: 'dd/mm/yy',
  dateIs: 'La date est',
  dateIsNot: "La date n'est pas",
  dayNames: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
  dayNamesMin: ['dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam'],
  dayNamesShort: ['dim', 'lundi', 'mardi', 'mercr', 'jeudi', 'vendr', 'sam'],
  emptyFilterMessage: 'Aucun résultat trouvé',
  emptyMessage: 'Aucune option disponible',
  emptySearchMessage: 'Aucun résultat trouvé',
  emptySelectionMessage: 'Aucun élément sélectionné',
  endsWith: 'Se termine par',
  equals: 'Égal à',
  fileSizeTypes: ['o', 'Ko', 'Mo', 'Go', 'To', 'Po', 'Eo', 'Zo', 'Yo'],
  firstDayOfWeek: 1,
  gt: 'Supérieur à',
  gte: 'Supérieur ou égal à',
  lt: 'Inférieur à',
  lte: 'Inférieur ou égal à',
  matchAll: 'Correspond à tous',
  matchAny: 'Au moins un Correspond',
  medium: 'Moyen',
  monthNames: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'],
  monthNamesShort: ['janv', 'févr', 'mars', 'avr', 'mai', 'juin', 'juill', 'août', 'sept', 'oct', 'nov', 'déc'],
  nextDecade: 'Décennie suivante',
  nextHour: 'Heure suivante',
  nextMinute: 'Minute suivante',
  nextMonth: 'Mois suivant',
  nextSecond: 'Seconde suivante',
  nextYear: 'Année suivante',
  noFilter: 'Aucun filtre',
  notContains: 'Ne contient pas',
  notEquals: 'Différent de',
  passwordPrompt: 'Saisissez un mot de passe',
  pending: 'En attente',
  pm: 'pm',
  prevDecade: 'Décennie précédente',
  prevHour: 'Heure précédente',
  prevMinute: 'Minute précédente',
  prevMonth: 'Mois précédent',
  prevSecond: 'Seconde précédente',
  prevYear: 'Année précédente',
  reject: 'Non',
  removeRule: 'Retirer une règle',
  searchMessage: '{0} résultats disponibles',
  selectionMessage: '{0} éléments sélectionnés',
  startsWith: 'Commence par',
  strong: 'Fort',
  today: "Aujourd'hui",
  upload: 'Envoyer',
  weak: 'Faible',
  weekHeader: 'Sem',
  aria: {
    cancelEdit: "Annule l'édition",
    close: 'Fermer',
    collapseRow: 'Ligne repliée',
    editRow: 'Édite une ligne',
    expandRow: 'Ligne dépliée',
    falseLabel: 'Faux',
    filterConstraint: 'Contrainte de filtrage',
    filterOperator: 'Opérateur de filtrage',
    firstPageLabel: 'Première page',
    gridView: 'Vue en grille',
    hideFilterMenu: 'Masque le menu des filtres',
    jumpToPageDropdownLabel: 'Aller à la page',
    jumpToPageInputLabel: 'Aller à la page',
    lastPageLabel: 'Dernière page',
    listView: 'Vue en liste',
    moveAllToSource: 'Tout déplacer vers la source',
    moveAllToTarget: 'Tout déplacer vers la cible',
    moveBottom: 'Déplacer tout en bas',
    moveDown: 'Déplacer vers le bas',
    moveTop: 'Déplacer tout en haut',
    moveToSource: 'Déplacer vers la source',
    moveToTarget: 'Déplacer vers la cible',
    moveUp: 'Déplacer vers le haut',
    navigation: 'Navigation',
    next: 'Suivant',
    nextPageLabel: 'Page suivante',
    nullLabel: 'Aucune sélection',
    pageLabel: 'Page {page}',
    previous: 'Précédent',
    previousPageLabel: 'Page précédente',
    removeLabel: 'Retirer',
    rotateLeft: 'Tourner vers la gauche',
    rotateRight: 'Tourner vers la droite',
    rowsPerPageLabel: 'Lignes par page',
    saveEdit: "Sauvegarde l'édition",
    scrollTop: 'Défiler tout en haut',
    selectAll: 'Tous éléments sélectionnés',
    selectRow: 'Ligne sélectionnée',
    showFilterMenu: 'Montre le menu des filtres',
    slide: 'Diapositive',
    slideNumber: '{slideNumber}',
    star: '1 étoile',
    stars: '{star} étoiles',
    trueLabel: 'Vrai',
    unselectAll: 'Tous éléments désélectionnés',
    unselectRow: 'Ligne désélectionnée',
    zoomImage: "Zoomer l'image",
    zoomIn: 'Zoomer',
    zoomOut: 'Dézoomer',
  },
};

export const en = {
  accept: 'Yes',
  addRule: 'Add rule',
  am: 'am',
  apply: 'Apply',
  cancel: 'Cancel',
  choose: 'Choose',
  chooseDate: 'Choose a date',
  chooseMonth: 'Choose a month',
  chooseYear: 'Choose a year',
  clear: 'Clear',
  contains: 'Contains',
  dateAfter: 'After',
  dateBefore: 'Before',
  dateFormat: 'mm/dd/yy',
  dateIs: 'Date is',
  dateIsNot: 'Date is not',
  dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  emptyFilterMessage: 'No results found',
  emptyMessage: 'No options available',
  emptySearchMessage: 'No results found',
  emptySelectionMessage: 'No item selected',
  endsWith: 'Ends with',
  equals: 'Equals',
  fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
  firstDayOfWeek: 0,
  gt: 'Greater than',
  gte: 'Greater than or equal to',
  lt: 'Less than',
  lte: 'Less than or equal to',
  matchAll: 'Match all',
  matchAny: 'Match any',
  medium: 'Medium',
  monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  nextDecade: 'Next decade',
  nextHour: 'Next hour',
  nextMinute: 'Next minute',
  nextMonth: 'Next month',
  nextSecond: 'Next second',
  nextYear: 'Next year',
  noFilter: 'No filter',
  notContains: 'Does not contain',
  notEquals: 'Not equals',
  passwordPrompt: 'Enter a password',
  pending: 'Pending',
  pm: 'pm',
  prevDecade: 'Previous decade',
  prevHour: 'Previous hour',
  prevMinute: 'Previous minute',
  prevMonth: 'Previous month',
  prevSecond: 'Previous second',
  prevYear: 'Previous year',
  reject: 'No',
  removeRule: 'Remove rule',
  searchMessage: '{0} results are available',
  selectionMessage: '{0} items selected',
  startsWith: 'Starts with',
  strong: 'Strong',
  today: 'Today',
  upload: 'Upload',
  weak: 'Weak',
  weekHeader: 'Wk',
  aria: {
    cancelEdit: 'Cancel edit',
    close: 'Close',
    collapseRow: 'Row collapsed',
    editRow: 'Edit row',
    expandRow: 'Row expanded',
    falseLabel: 'False',
    filterConstraint: 'Filter constraint',
    filterOperator: 'Filter operator',
    firstPageLabel: 'First page',
    gridView: 'Grid view',
    hideFilterMenu: 'Hide filter menu',
    jumpToPageDropdownLabel: 'Go to page',
    jumpToPageInputLabel: 'Go to page',
    lastPageLabel: 'Last page',
    listView: 'List view',
    moveAllToSource: 'Move all to source',
    moveAllToTarget: 'Move all to target',
    moveBottom: 'Move bottom',
    moveDown: 'Move down',
    moveTop: 'Move top',
    moveToSource: 'Move to source',
    moveToTarget: 'Move to target',
    moveUp: 'Move up',
    navigation: 'Navigation',
    next: 'Next',
    nextPageLabel: 'Next page',
    nullLabel: 'No selection',
    pageLabel: 'Page {page}',
    previous: 'Previous',
    previousPageLabel: 'Previous page',
    removeLabel: 'Remove',
    rotateLeft: 'Rotate left',
    rotateRight: 'Rotate right',
    rowsPerPageLabel: 'Rows per page',
    saveEdit: 'Save edit',
    scrollTop: 'Scroll top',
    selectAll: 'All items selected',
    selectRow: 'Row selected',
    showFilterMenu: 'Show filter menu',
    slide: 'Slide',
    slideNumber: '{slideNumber}',
    star: '1 star',
    stars: '{star} stars',
    trueLabel: 'True',
    unselectAll: 'All items unselected',
    unselectRow: 'Row unselected',
    zoomImage: 'Zoom image',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
  },
};

export const es = {
  accept: 'Sí',
  addRule: 'Añadir regla',
  am: 'am',
  apply: 'Aplicar',
  cancel: 'Cancelar',
  choose: 'Elegir',
  chooseDate: 'Elegir una fecha',
  chooseMonth: 'Elegir un mes',
  chooseYear: 'Elegir un año',
  clear: 'Limpiar',
  contains: 'Contiene',
  dateAfter: 'Después de',
  dateBefore: 'Antes de',
  dateFormat: 'dd/mm/yy',
  dateIs: 'La fecha es',
  dateIsNot: 'La fecha no es',
  dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
  dayNamesMin: ['do', 'lu', 'ma', 'mi', 'ju', 'vi', 'sa'],
  dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
  emptyFilterMessage: 'No se han encontrado resultados',
  emptyMessage: 'No hay opciones disponibles',
  emptySearchMessage: 'No se han encontrado resultados',
  emptySelectionMessage: 'Ningún elemento seleccionado',
  endsWith: 'Termina con',
  equals: 'Igual a',
  fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
  firstDayOfWeek: 1,
  gt: 'Mayor que',
  gte: 'Mayor o igual que',
  lt: 'Menor que',
  lte: 'Menor o igual que',
  matchAll: 'Coincide con todos',
  matchAny: 'Coincide con alguno',
  medium: 'Medio',
  monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
  monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
  nextDecade: 'Década siguiente',
  nextHour: 'Hora siguiente',
  nextMinute: 'Minuto siguiente',
  nextMonth: 'Mes siguiente',
  nextSecond: 'Segundo siguiente',
  nextYear: 'Año siguiente',
  noFilter: 'Sin filtro',
  notContains: 'No contiene',
  notEquals: 'No es igual a',
  passwordPrompt: 'Introduzca una contraseña',
  pending: 'Pendiente',
  pm: 'pm',
  prevDecade: 'Década anterior',
  prevHour: 'Hora anterior',
  prevMinute: 'Minuto anterior',
  prevMonth: 'Mes anterior',
  prevSecond: 'Segundo anterior',
  prevYear: 'Año anterior',
  reject: 'No',
  removeRule: 'Eliminar regla',
  searchMessage: '{0} resultados disponibles',
  selectionMessage: '{0} elementos seleccionados',
  startsWith: 'Empieza por',
  strong: 'Fuerte',
  today: 'Hoy',
  upload: 'Subir',
  weak: 'Débil',
  weekHeader: 'Sem',
  aria: {
    cancelEdit: 'Cancelar edición',
    close: 'Cerrar',
    collapseRow: 'Fila plegada',
    editRow: 'Editar fila',
    expandRow: 'Fila desplegada',
    falseLabel: 'Falso',
    filterConstraint: 'Restricción de filtro',
    filterOperator: 'Operador de filtro',
    firstPageLabel: 'Primera página',
    gridView: 'Vista de cuadrícula',
    hideFilterMenu: 'Ocultar menú de filtro',
    jumpToPageDropdownLabel: 'Ir a la página',
    jumpToPageInputLabel: 'Ir a la página',
    lastPageLabel: 'Última página',
    listView: 'Vista de lista',
    moveAllToSource: 'Mover todo a origen',
    moveAllToTarget: 'Mover todo a destino',
    moveBottom: 'Mover al final',
    moveDown: 'Mover hacia abajo',
    moveTop: 'Mover al principio',
    moveToSource: 'Mover a origen',
    moveToTarget: 'Mover a destino',
    moveUp: 'Mover hacia arriba',
    navigation: 'Navegación',
    next: 'Siguiente',
    nextPageLabel: 'Página siguiente',
    nullLabel: 'Sin selección',
    pageLabel: 'Página {page}',
    previous: 'Anterior',
    previousPageLabel: 'Página anterior',
    removeLabel: 'Eliminar',
    rotateLeft: 'Girar a la izquierda',
    rotateRight: 'Girar a la derecha',
    rowsPerPageLabel: 'Filas por página',
    saveEdit: 'Guardar edición',
    scrollTop: 'Desplazar arriba',
    selectAll: 'Todos los elementos seleccionados',
    selectRow: 'Fila seleccionada',
    showFilterMenu: 'Mostrar menú de filtros',
    slide: 'Diapositiva',
    slideNumber: '{slideNumber}',
    star: '1 estrella',
    stars: '{star} estrellas',
    trueLabel: 'Verdadero',
    unselectAll: 'Todos los elementos deseleccionados',
    unselectRow: 'Fila deseleccionada',
    zoomImage: 'Ampliar imagen',
    zoomIn: 'Acercar',
    zoomOut: 'Alejar',
  },
};

export const it = {
  accept: 'Sì',
  addRule: 'Aggiungi regola',
  am: 'am',
  apply: 'Applica',
  cancel: 'Annulla',
  choose: 'Scegli',
  chooseDate: 'Scegli una data',
  chooseMonth: 'Scegli un mese',
  chooseYear: 'Scegli un anno',
  clear: 'Cancella',
  contains: 'Contiene',
  dateAfter: 'Dopo',
  dateBefore: 'Prima',
  dateFormat: 'dd/mm/yy',
  dateIs: 'La data è',
  dateIsNot: 'La data non è',
  dayNames: ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'],
  dayNamesMin: ['do', 'lu', 'ma', 'me', 'gi', 've', 'sa'],
  dayNamesShort: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
  emptyFilterMessage: 'Nessun risultato trovato',
  emptyMessage: 'Nessuna opzione disponibile',
  emptySearchMessage: 'Nessun risultato trovato',
  emptySelectionMessage: 'Nessun elemento selezionato',
  endsWith: 'Termina con',
  equals: 'Uguale a',
  fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
  firstDayOfWeek: 1,
  gt: 'Maggiore di',
  gte: 'Maggiore o uguale a',
  lt: 'Minore di',
  lte: 'Minore o uguale a',
  matchAll: 'Corrisponde a tutti',
  matchAny: 'Corrisponde ad almeno uno',
  medium: 'Medio',
  monthNames: ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'],
  monthNamesShort: ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'],
  nextDecade: 'Decennio successivo',
  nextHour: 'Ora successiva',
  nextMinute: 'Minuto successivo',
  nextMonth: 'Mese successivo',
  nextSecond: 'Secondo successivo',
  nextYear: 'Anno successivo',
  noFilter: 'Nessun filtro',
  notContains: 'Non contiene',
  notEquals: 'Diverso da',
  passwordPrompt: 'Inserisci una password',
  pending: 'In sospeso',
  pm: 'pm',
  prevDecade: 'Decennio precedente',
  prevHour: 'Ora precedente',
  prevMinute: 'Minuto precedente',
  prevMonth: 'Mese precedente',
  prevSecond: 'Secondo precedente',
  prevYear: 'Anno precedente',
  reject: 'No',
  removeRule: 'Rimuovi regola',
  searchMessage: '{0} risultati disponibili',
  selectionMessage: '{0} elementi selezionati',
  startsWith: 'Inizia con',
  strong: 'Forte',
  today: 'Oggi',
  upload: 'Carica',
  weak: 'Debole',
  weekHeader: 'Set',
  aria: {
    cancelEdit: 'Annulla modifica',
    close: 'Chiudi',
    collapseRow: 'Riga compressa',
    editRow: 'Modifica riga',
    expandRow: 'Riga espansa',
    falseLabel: 'Falso',
    filterConstraint: 'Vincolo di filtro',
    filterOperator: 'Operatore di filtro',
    firstPageLabel: 'Prima pagina',
    gridView: 'Vista griglia',
    hideFilterMenu: 'Nascondi menu filtro',
    jumpToPageDropdownLabel: 'Vai alla pagina',
    jumpToPageInputLabel: 'Vai alla pagina',
    lastPageLabel: 'Ultima pagina',
    listView: 'Vista elenco',
    moveAllToSource: 'Sposta tutto alla sorgente',
    moveAllToTarget: 'Sposta tutto alla destinazione',
    moveBottom: 'Sposta in fondo',
    moveDown: 'Sposta giù',
    moveTop: 'Sposta in cima',
    moveToSource: 'Sposta alla sorgente',
    moveToTarget: 'Sposta alla destinazione',
    moveUp: 'Sposta su',
    navigation: 'Navigazione',
    next: 'Successivo',
    nextPageLabel: 'Pagina successiva',
    nullLabel: 'Nessuna selezione',
    pageLabel: 'Pagina {page}',
    previous: 'Precedente',
    previousPageLabel: 'Pagina precedente',
    removeLabel: 'Rimuovi',
    rotateLeft: 'Ruota a sinistra',
    rotateRight: 'Ruota a destra',
    rowsPerPageLabel: 'Righe per pagina',
    saveEdit: 'Salva modifica',
    scrollTop: 'Torna in alto',
    selectAll: 'Tutti gli elementi selezionati',
    selectRow: 'Riga selezionata',
    showFilterMenu: 'Mostra menu filtro',
    slide: 'Diapositiva',
    slideNumber: '{slideNumber}',
    star: '1 stella',
    stars: '{star} stelle',
    trueLabel: 'Vero',
    unselectAll: 'Tutti gli elementi deselezionati',
    unselectRow: 'Riga deselezionata',
    zoomImage: 'Zoom immagine',
    zoomIn: 'Ingrandisci',
    zoomOut: 'Riduci',
  },
};
